var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(language){return _c('ListItem',{key:language.code,attrs:{"title":language.name}},[_c('AeRadio',{attrs:{"slot":"right","checked":language === _vm.active},on:{"change":function($event){return _vm.setLanguage(language)}},slot:"right"})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }